<div class="rectangle-div w-full h-full">
  <div class="h-full w-full relative overflow-hidden">
    <div class="noise-bg h-full w-full absolute">
      <img src="/assets/images/side-bg-new.svg" class="bg-img absolute" />
    </div>
    <ng-container *ngIf="customTemplate">
      <div class="h-full w-full absolute">
        <ng-template [ngTemplateOutlet]="customTemplate"></ng-template>
      </div>
    </ng-container>
    <ng-container *ngIf="!customTemplate">
      <img
        src="/assets/images/side-person-2.webp"
        class="person-img absolute"
      />
      <div class="glass-note-holder w-full absolute flex justify-center px-5">
        <div class="note-container w-full">
          <div class="description">
            “You have power over your mind - not outside events. Realize this, and you will find strength.”
          </div>
          <div class="author text-right">Marcus Aurelius</div>
        </div>
      </div>
      <a
        class="home-link absolute flex items-center"
        target="_blank"
        href="https://aureliusencephalon.com.au"
      >
        {{ "aureliusencephalon.com.au" }}
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.3365 2.84514L2.16435 10.0173L0.98584 8.8388L8.158 1.66664H1.83652V-3.05176e-05H11.0032V9.16664H9.3365V2.84514Z"
            fill="white"
          />
        </svg>
      </a>
    </ng-container>
  </div>
</div>
